import MotionMail from '@components/sections/motionMail'
import { ICourse2 } from '@et/types/Courses'
import React from 'react'

export default function PatternLetsDoThis(props: ICourse2) {
  const { motionMail } = props

  return (
    <div className='pt-12 et-grid-basic bg-cream-200 md:gap-y-0 md:pt-20'>

      <h2 className='col-span-2 col-start-2 mb-8 text-center section-h2 font-sentinel__SemiBoldItal md:col-start-3 md:col-span-10 '>
        Making patterns is fun again, <span className='text-rusted-400'>especially</span> in Procreate
      </h2>

      <p className='col-span-2 col-start-2 md:col-start-3 md:col-span-10 md:text-xl xl:col-start-4 xl:col-span-8'>
        Create those beautiful stop-and-stare patterns you have waiting inside of you onto the screen and into the world. Gain the peace of mind knowing they're made non destructively, were fully (and properly!) tested, and made at the correct size, resolution and color profile.
      </p>
      {/* 
      <h3 className='col-span-2 col-start-2 mt-8 text-center section-h2 font-sentinel__SemiBoldItal md:col-start-3 md:col-span-10'>Let's do this!</h3> */}
      {/* <p className='col-span-2 col-start-2 my-4 text-xl font-bold text-center text-rusted-400 md:col-start-3 md:col-span-10'>Intro price expires in:</p>

      <div className='col-span-2 col-start-2 md:col-start-4 md:col-span-8 lg:col-start-5 lg:col-span-6'>
        <MotionMail
          backgroundColor='transparent'
          motionMailLink={motionMail} />
      </div> */}

    </div>
  )
}
